module.exports = __webpack_public_path__ + "img/scene_family.519dbf8a.webp";